import { montarURLFiltro } from '../../util/filtros';
import { URL } from '../../util/ambienteActions';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { BUSCAR_PEDIDOS, LISTAR_FILTROS_PEDIDOS } from '../types';

export const getUrlFormatadaFiltros = (filtros, pagina, registrosPorPagina) =>`${URL}/pedido/pedidos-por-usuario-logado${montarURLFiltro(filtros, pagina, registrosPorPagina)}`

export const buscaPedidoGeral = (filtrosPedido, pagina, registrosPorPagina, filtros) =>
    dispatch => axios.get(getUrlFormatadaFiltros(filtros, pagina, registrosPorPagina), SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_PEDIDOS,
      payload: {
        pedidos: response.data,
        existeFiltro: filtrosPedido && filtrosPedido.length > 0
      }
    })
  )

export const  listarFiltrosPedidos = idEmpresa => dispatch => axios.get(`${URL}/pedido/empresa/${idEmpresa}/filtros-geral`)
    .then(response => dispatch({
        type: LISTAR_FILTROS_PEDIDOS,
        payload: response
      })
    )
